import {Component, ViewChild} from '@angular/core';
import {
    NavParams,
    TextInput,
    ViewController
} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {DomSanitizer} from "@angular/platform-browser";
import {CONFIG} from "../../../app/config";

@Component({
    selector: 'page-modal-action',
    templateUrl: 'modal-action.html',
    providers: []
})
export class ModalActionPage {

    config: any;

    hotspot: any;
    modalinfo: any;
    modalfull: boolean;
    modaldata: any;
    modalerro: any;
    downstore: boolean;

    modalcima: string;

    selected: boolean;
    perfilfnd: any;
    writeryes: boolean;
    hiddenyes: boolean;

    debugIndex: number;

    @ViewChild('inputDocumento') inputDocumento: TextInput;

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public sanitizer: DomSanitizer) {

        this.config = CONFIG;

        this.hotspot = this.navParams.get('hotspot');
        this.modalinfo = this.navParams.get('modalinfo');
        this.modalfull = this.navParams.get('modalfull');
        this.writeryes = this.navParams.get('writeryes');
        this.hiddenyes = false;

        this.modaldata = null;
        this.modalerro = null;
        this.downstore = false;

        this.modalcima = this.modalinfo.corcor;
        this.modalinfo.corcor = (this.modalinfo.corcor == 'CorMilk' ? 'CorDash' : this.modalinfo.corcor);

        //this.debugtest(0);


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Modal Action - ' + this.modalinfo.header, '/modal-action/' + this.modalinfo.header);

        if (this.modalinfo.window == 'animeload') this.actionClick(null);

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    actionOnoff() {

        if (!this.modalinfo.action) return false;

        return (!this.modalinfo.select) ||
        (this.modalinfo.select && this.selected) ||
        (!this.modalinfo.select && (!this.modalinfo.inputf || !this.modalinfo.inputf.mask && this.modalinfo.inputf.text && this.modalinfo.inputf.text.length)) ||
        (!this.modalinfo.select && (!this.modalinfo.inputf || this.modalinfo.inputf.mask && this.modalinfo.inputf.text && this.modalinfo.inputf.text.length == this.modalinfo.inputf.mask.length));

    }

    iconimg(tipo?) {

        let icon = (this.modalinfo.imagem.slice(0, 6) == 'b-icon');
        return (tipo == 'icon' && icon) || (tipo != 'icon' && !icon);

    }

    plusClick() {

        this.modalinfo.onPlus(this.modalinfo, this, this.modaldata);

    }

    actionClick(event) {

        //this.debugtest(this.debugIndex +1);
        //return;


        if (event && event.keyCode && event.keyCode != 13) return;

        let mascara = (this.modalinfo.inputf && (this.modalinfo.inputf.mask == '000.000.000-00' || this.modalinfo.inputf.mask == '00.000.000/0000-00'));
        if (mascara && !this.util.validaRnid(this.modalinfo.inputf.text)) {
            this.util.alertSimply(this.util.traduzDOC(this.modalinfo.inputf.text) + ' inválido');
            return;
        }


        if (this.modalinfo.observ) {

            let loading = this.util.loadingDots();
            if (this.modalinfo.window != 'animeload') loading.present();

            this.modalinfo.observ
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        //GAMBI - LENTO (Para deixar lento a resposta proposital, quando chega muito rapido para ver a animeload)
                        setTimeout(() => {

                            this.hiddenyes = true;
                            this.writeryes = true;

                            this.modaldata = data;
                            if (this.modalinfo.onOkey == null) this.dismiss();
                            else this.modalinfo.onOkey(this.modalinfo, this, data);

                            setTimeout(() => this.hiddenyes = false);

                        }, 1000);

                    },
                    erro => {

                        //GAMBI - LENTO (Para deixar lento a resposta proposital, quando chega muito rapido para ver a animeload)
                        setTimeout(() => {

                            this.hiddenyes = true;
                            this.writeryes = true;

                            this.modalerro = erro;

                            let codepos = erro.Result.indexOf(']') + 1;
                            erro.Header = (erro.Result[0] != '[' ? 'Erro' : 'Erro ' + erro.Result.substring(0, codepos));
                            erro.Result = (erro.Result[0] != '[' ? erro.Result : erro.Result.substring(codepos+1, 99));

                            this.modalinfo.window = 'animeerro';
                            this.modalinfo.corcor = 'CorVerm';
                            this.modalinfo.header = erro.Header;
                            this.modalinfo.titulo = erro.Titulo;
                            this.modalinfo.resumo = erro.Result;
                            this.modalinfo.imagem = 'assets/img/emoticon/em-updatecry.png';
                            this.modalinfo.select = null;
                            this.modalinfo.inputf = null;
                            this.modalinfo.action = null;
                            this.modalinfo.observ = null;
                            this.modalinfo.linhas = null;

                            setTimeout(() => this.hiddenyes = false);
                            //this.util.alertResult(erro)

                        }, 1000);

                    });

            return;
        }

        this.modalinfo.onOkey(this.modalinfo, this, this.modaldata);

    }

    tecladoOkey(btn) {

        this.modalinfo.inputf.text = this.modalinfo.inputf.text.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        this.modalinfo.inputf.text = this.modalinfo.inputf.text.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

        if (btn == 'ok') {
            this.modalinfo.onOkey(this.modalinfo, this, this.modaldata);
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {

            this.modalinfo.inputf.text = '';
            
        }

        else if (btn == 'left-thin') {
            this.modalinfo.inputf.text = this.modalinfo.inputf.text.slice(0, this.modalinfo.inputf.text.length-1);
        }

        else if (btn == 'dot') {

        }

        else {
            this.modalinfo.inputf.text = this.modalinfo.inputf.text + btn;
        }

        let tecladoText = this.modalinfo.inputf.text;
        if (tecladoText.length <= 4) this.modalinfo.inputf.text = tecladoText;
        if (tecladoText.length == 5) this.modalinfo.inputf.text = tecladoText[0] + tecladoText[1] + '.' + tecladoText[2] + tecladoText[3] + tecladoText[4];
        if (tecladoText.length >= 6) this.modalinfo.inputf.text = tecladoText[0] + tecladoText[1] + tecladoText[2] + '.' + tecladoText[3] + tecladoText[4] + (tecladoText[5] || '') + (tecladoText[6] ? '.' + tecladoText[6] : '') + (tecladoText[7] || '') + (tecladoText[8] || '') + (tecladoText[9] ? '-' + tecladoText[9] : '')  + (tecladoText[10] || '');

    }


    debugtest(index) {

        this.debugIndex = index;

    }

    openStore() {

        if (this.util.downloadApp('ios')) {
            this.util.open(this.config.paths.appStoreLink, '_blank', '');
        }

        if (this.util.downloadApp('android')) {
            this.util.open(this.config.paths.playStoreLink, '_blank', '');
        }

    }

    dismiss() {

        this.viewCtrl.dismiss(this.modaldata);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/modal-action/modal-action.ts